import services from '../services/api';
const initialState = {
  menu: [],
  headHighlight: [],
  asideHighlight: []
};
export default {
  name: 'menu',
  state: initialState,
  reducers: {
    updateMenu: (state, { data }) => {
      return {
        ...state,
        menu: data
      };
    },
    updateHeadHighlight: (state, { ids }) => {
      return {
        ...state,
        headHighlight: ids
      };
    },
    updateAsideHighlight: (state, { ids }) => {
      return {
        ...state,
        asideHighlight: ids
      };
    }
  },
  effects: {
    queryMenuConfig: async ({ params }, { dispatch }) => {
      const res = await services.menuConfig.query(params);
      dispatch({ type: 'menu/updateMenu', data: res.data });
      return res.data;
    }
  }
};
